import {
  ChorinicityType,
  DoctorInformation,
  Ethnicity,
  GestationAge,
  InVitro,
  PregnancyType,
} from './service-data.types';

export interface NipptServiceInformation {
  doctorInformation: DoctorInformation;
  allegedFather?: NipptAllegedFather;
  patientHistory?: NipptPatientHistoryInformation;
  currentPregnancyInformation?: NipptCurrentPregnancyInformation;
  ethnicity?: string;
  comments?: string;
}

export interface NipptAllegedFather {
  firstName: string;
  lastName: string;
  documentNumber: string;
  dateOfBirth: string;
  email: string;
  phoneNumber: string;
  ethnicity: Ethnicity | string;
}

export interface NipptPatientHistoryInformation {
  anotherPregnancy: NipptAnotherPregnancy;
  // "Has either participant received …"
  anyReceivedStemCell: boolean;
  anyReceivedBloodTransfusion: boolean;
}

// Pregnant with another child in the last 6 months. Asked only when
// gestation age is under 8 weeks; type and date only when wasPregnant.
export interface NipptAnotherPregnancy {
  wasPregnant: boolean | null;
  type: AnotherPregnancyType | null;
  date: string | null;
}

export enum AnotherPregnancyType {
  Miscarriage = 'Miscarriage',
  Abortion = 'Abortion',
  Delivery = 'Delivery',
}

export interface NipptCurrentPregnancyInformation {
  expectedConfinementDate: Date;
  gestationAge: GestationAge;
  isGestationAgeAutomaticallyCalculated: boolean;
  pregnancyType: PregnancyType;
  chorionicityType: ChorinicityType;
  inVitro: InVitro;
}

// SAMPLE
export interface NipptSampleServiceInformation {
  doctorId: string;
  sampleType: string;
  // Free text when the sample type is "Other"
  otherType: string | null;
}
